import { createFileRoute } from "@tanstack/react-router";

import { DashboardPage } from "@/components/Pages";

export const Route = createFileRoute("/_guard/")({
  component: DashboardPage,
});
